/*
 * @Author: your name
 * @Date: 2020-07-30 15:32:11
 * @LastEditTime: 2020-08-03 16:43:16
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/vender/form-schema-config/components/form-text-input.config.js
 */
import Vue from 'vue'
const apis = {
  // 查询地址
  QUERY_AREA: {
    url: '/xdap-admin/province/query/province',
    method: 'post',
    disableSuccessMsg: true
  }
}
const queryArea = (params) => {
  return new Promise((resolve, reject) => {
    const request = {
      ...apis.QUERY_AREA,
      params
    }
    Vue.prototype
      .$request(request)
      .asyncThen(
        (resp) => {
          if (resp.code === 'ok') {
            resolve({
              data: resp.data
            })
          }
        },
        (err) => {
          reject(err)
        }
      )
      .asyncErrorCatch((err) => {
        reject(err)
      })
  })
}
const FormWidgetAreaConfig = {
  // 类型
  componentType: 'FORM_WIDGET_AREA',
  // 部件显示样式
  widgetConfig: {
    icon: 'x-lib-area',
    text: '地区',
    optionTitle: true,
    description: '用于记录地区或地址，支持地图选取地址'
  },
  componentConfig: {
    uuid: `32bit uuid`,
    width: 12, // 3, 6, 9, 12
    height: 1,
    render: {
      ide: 'FormWidgetArea',
      edit: 'FormWidgetArea',
      read: 'FormWidgetArea'
    },
    label: '地区',
    areaType: 'AREA',
    areaDefault: {
      province: {
        code: '',
        name: ''
      },
      city: {
        code: '',
        name: ''
      },
      area: {
        code: '',
        name: ''
      },
      address: {
        name: ''
      }
    },
    queryArea: queryArea,
    customDefaultKey: 'areaDefault',
    methods: {
      lcInitData: {
        edit: (...args) => {
        }
      },
      lcConvertDefaultValue: (config) => {
        return config.areaDefault
      }
    }
  },
  methods: {},
  editorConfig: [
    'INFO',
    'LABEL',
    'AREA_TYPE',
    'AREA_DAFAULT',
    'HIDDEN',
    'READONLY',
    'REQUIRED',
    'EDITONNEW'
  ]
}

export default FormWidgetAreaConfig
